import StickyGallery from './StickyGallery';
export default StickyGallery;